import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {FormsModule} from "@angular/forms";
import {ClarityModule} from "@clr/angular";
import {NgClass} from "@angular/common";

@Component({
  selector: 'colimo-filter-checkboxes-part',
  templateUrl: './filter-checkboxes-part.component.html',
  imports: [
    FormsModule,
    ClarityModule,
    NgClass
  ],
  styleUrls: ['./filter-checkboxes-part.component.scss']
})
export class FilterCheckboxesPartComponent implements OnInit {

  @Input()
  public partName: string;

  @Input()
  public filterItems: string[];

  @Input()
  public filterItemsSelected: boolean[];

  @Output()
  public filterItemChangedEvent: EventEmitter<number> = new EventEmitter();

  public constructor() { }

  public ngOnInit(): void {
  }

  public onFilterItemChange(changedFilterItemIndex: number): void {
    this.filterItemChangedEvent.emit(changedFilterItemIndex);
  }

}
